import { CollectionProductImage } from '../../../collections/CollectionProductItem/CollectionProductImage';
import { CollectionProductTitle } from '../../../collections/CollectionProductItem/CollectionProductTitle';
import { CollectionProductStockStatus } from '../../../collections/CollectionProductItem/CollectionProductStockStatus';
import { CollectionProductPrice } from '../../../collections/CollectionProductItem/CollectionProductNetPrice';
import PrimaryBtn from '../../../shared/Buttons/PrimaryButton';
import React from 'react';
import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ProductSearch } from '../../../../models/ProductSearch';

const StyledWrapper = styled(Box)(() => ({
    borderBottom: '1px solid #f5f5f5',
    paddingLeft: '10px',
    paddingRight: '10px',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    columnGap: '24px',
}));

const StyledImage = styled(Box)(() => ({
    width: '90px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    img: {
        maxWidth: '90px',
    },
}));

const StyledTitle = styled(Box)(({ theme }) => ({
    width: '60%',
    [theme.breakpoints.only('md')]: {
        width: '40%',
    },
    [theme.breakpoints.down('md')]: {
        width: '100%',
    },
}));

const StyledContent = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    [theme.breakpoints.down('md')]: {
        alignItems: 'start',
        flexDirection: 'column',
        width: '100%',
    },
}));

const StyledContainer = styled(Box)(({ theme }) => ({
    width: '100%',
    gap: '24px',
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        gap: '12px',
    },
}));

const StyledButtonWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
        width: '100%',
    },
}));

const StyledBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: '10px',
    justifyContent: 'end',
    [theme.breakpoints.down('md')]: {
        '&.details': {
            justifyContent: 'start',
        },
    },
}));

const StyledDetails = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'end',
    [theme.breakpoints.down('md')]: {
        justifyContent: 'start',
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'start',
    },
}));

const SearchHintItem: React.FC<{
    product: ProductSearch;
    handleAddProduct: (product) => void;
}> = ({ product, handleAddProduct }) => {
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_EDITOR.ADD_PRODUCT_DIALOG',
    });

    return (
        <StyledWrapper key={product.id}>
            <StyledImage>
                <CollectionProductImage imageSrc={product.image} />
            </StyledImage>
            <StyledContent>
                <StyledTitle>
                    <CollectionProductTitle product={product} />
                </StyledTitle>

                <StyledContainer>
                    <StyledDetails>
                        <CollectionProductStockStatus
                            quantity={product.stock}
                        />
                        <CollectionProductPrice
                            price={product.price}
                            alignItems={'left'}
                        />
                    </StyledDetails>
                </StyledContainer>
                <StyledButtonWrapper>
                    <StyledBox sx={{ paddingBottom: '10px' }}>
                        <PrimaryBtn onClick={() => handleAddProduct(product)}>
                            {t('ADD')}
                        </PrimaryBtn>
                    </StyledBox>
                </StyledButtonWrapper>
            </StyledContent>
        </StyledWrapper>
    );
};

export default SearchHintItem;
